var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12 box-shadow"},[_c('advanced',{attrs:{"col":_vm.col,"getData":_vm.getData,"DownloadURL":_vm.DownloadURL,"Options":_vm.Options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }